  document.addEventListener('DOMContentLoaded', function() {
    console.clear();
    // console.log('creators-gallery.js loaded');
    const slides = document.querySelectorAll('.creator-gallery-slide');
    const lightbox = document.querySelector('.creator-lightbox');
    const lightboxVideo = lightbox.querySelector('video');
    const closeBtn = lightbox.querySelector('.creator-lightbox-close');

    slides.forEach(slide => {
      slide.addEventListener('click', function() {
        const videoSrc = this.getAttribute('data-video-src');
        const videoType = this.getAttribute('data-video-type');

        // console.log(videoSrc, videoType);

        if (videoSrc) {
          lightboxVideo.src = videoSrc;
          lightboxVideo.type = videoType || 'video/mp4';
          lightbox.classList.add('open');
          
          // Slight delay to ensure visibility before playing
          setTimeout(() => {
            lightboxVideo.play().catch(e => console.error("Video play failed", e));
          }, 100);
        }
      });
    });

    function closeLightbox() {
      lightbox.classList.remove('open');
      lightboxVideo.pause();
      lightboxVideo.src = ""; // Stop buffering
    }

    closeBtn.addEventListener('click', closeLightbox);
    
    // Close on click outside
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) {
        closeLightbox();
      }
    });
  });